import React, { PropTypes as T } from 'react';
import { Button, Icon, OutsideClickHandler } from 'b3';
import Bubble from 'b3/bubble/NewBubble';

export default class DropdownMenu extends React.Component {

    static propTypes = {
        openOnHover: T.bool,
        text: T.string,
        type: T.string,
        icon: T.string,
        showCaret: T.bool,
        template: T.func,
        backgroundColor: T.string,
        dropdownPosition: T.string,
        dropdownAlign: T.string,
    };

    static defaultProps = {
        backgroundColor: "#27353D",
        openOnHover: false,
        showCaret: true,
        dropdownPosition: 'bottom',
        dropdownAlign: 'right',
    };

    constructor(props) {
        super(props);

        this.hoverTimeout = null;

        this.state = {
            isOpen: false,
        };

    }

    handleButtonClick() {
        if (!this.props.openOnHover) {
            this.setState({ isOpen: !this.state.isOpen });
        }
    }

    handleButtonOrBubbleMouseOver() {

        if (this.hoverTimeout) {
            clearTimeout(this.hoverTimeout);
        }

        if (this.props.openOnHover && !this.state.isOpen) {
            this.setState({ isOpen: true });
        }
    }

    handleButtonOrBubbleMouseOut() {
        if (this.props.openOnHover && this.state.isOpen) {

            this.hoverTimeout = setTimeout(() => {
                this.setState({ isOpen: false });
            }, 500);

        }
        
    }

    handleOutsideClick() {
        if (this.state.isOpen) {
            this.setState({ isOpen: false });
        }
    }

    handleMenuItemClick() {
        this.setState({ isOpen: false });
    }

    renderInner() {
        if (this.props.template) {
            return this.props.template();
        }

        return (
            <div className="b3-dropdown-menu-inner">

                {this.props.icon &&
                    <Icon icon={this.props.icon} />
                }

                {this.props.text &&
                    <div style={{flex: 1}}>{this.props.text}</div>
                }

                {this.props.showCaret &&
                    <div className="b3-dropdown-menu-caret"></div>
                }

            </div>
        );
    }
    render() {

        //intercept menu item click
        var children = React.Children.map(this.props.children, (child) => {
            
            var menuClickHandler = () => {

                if (child.props.onMenuItemClick) {
                    child.props.onMenuItemClick();
                }
                
                this.handleMenuItemClick();
            };

            return React.cloneElement(child, { onMenuItemClick: menuClickHandler });

        });

        return (
            <div className="b3-dropdown-menu">

                <OutsideClickHandler onOutsideClick={this.handleOutsideClick.bind(this)}>
                    
                    <Button ref={ el => this.button = el } type={this.props.type} onClick={this.handleButtonClick.bind(this)} onMouseOver={this.handleButtonOrBubbleMouseOver.bind(this)} onMouseOut={this.handleButtonOrBubbleMouseOut.bind(this)}>
                        {this.renderInner()}
                    </Button>

                    {this.state.isOpen &&
                        <Bubble backgroundColor={this.props.backgroundColor} target={this.button} position={this.props.dropdownPosition} align={this.props.dropdownAlign} onMouseOver={this.handleButtonOrBubbleMouseOver.bind(this)} onMouseOut={this.handleButtonOrBubbleMouseOut.bind(this)}>
                            <div className="b3-dropdown-menu-list">
                                {children}
                            </div>
                        </Bubble>
                    }
                </OutsideClickHandler>

            </div>
            
        );
    }

}


// WEBPACK FOOTER //
// ./app/b3/dropdowns/DropdownMenu.js